/* This file is automatically generated for @graphcommerce/magento-search */

export * from '.'
import { Plugin as AlgoliaCategorySearchResults } from '@graphcommerce/algolia-search/plugins/AlgoliaCategorySearchResults'
import { Plugin as AlgoliaFiltersPlugin } from '@graphcommerce/algolia-search/plugins/AlgoliaFiltersPlugin'
import { Plugin as AlgoliaPageSearchResults } from '@graphcommerce/algolia-search/plugins/AlgoliaPageSearchResults'
import { Plugin as AlgoliaPaginationPlugin } from '@graphcommerce/algolia-search/plugins/AlgoliaPaginationPlugin'
import { Plugin as AlgoliaProductListCountPlugin } from '@graphcommerce/algolia-search/plugins/AlgoliaProductListCountPlugin'
import { Plugin as AlgoliaProductSearchResultsPlugin } from '@graphcommerce/algolia-search/plugins/AlgoliaProductSearchResultsPlugin'
import { Plugin as AlgoliaProductSortPlugin } from '@graphcommerce/algolia-search/plugins/AlgoliaProductSortPlugin'
import { Plugin as AlgoliaSearchContextPlugin } from '@graphcommerce/algolia-search/plugins/AlgoliaSearchContextPlugin'
import { Plugin as AlgoliaSearchFieldPlugin } from '@graphcommerce/algolia-search/plugins/AlgoliaSearchFieldPlugin'
import { ComponentProps } from 'react'
import { 
  SearchForm as SearchFormBase,
  ProductListFiltersSearch as ProductListFiltersSearchBase,
  ProductListPaginationSearch as ProductListPaginationSearchBase,
  ProductListCountSearch as ProductListCountSearchBase,
  ProductListItemsSearch as ProductListItemsSearchBase,
  ProductListSortSearch as ProductListSortSearchBase,
  SearchContext as SearchContextBase,
} from '.'

/**
 * Interceptor for `<SearchForm/>` with these plugins:
 * 
 * - `@graphcommerce/algolia-search/plugins/AlgoliaCategorySearchResults`
 * - `@graphcommerce/algolia-search/plugins/AlgoliaPageSearchResults`
 * - `@graphcommerce/algolia-search/plugins/AlgoliaSearchFieldPlugin`
 */
type SearchFormProps = ComponentProps<typeof SearchFormBase>

function AlgoliaSearchFieldPluginInterceptor(props: SearchFormProps) {
  return <AlgoliaSearchFieldPlugin {...props} Prev={SearchFormBase} />
}
function AlgoliaPageSearchResultsInterceptor(props: SearchFormProps) {
  return <AlgoliaPageSearchResults {...props} Prev={AlgoliaSearchFieldPluginInterceptor} />
}
function AlgoliaCategorySearchResultsInterceptor(props: SearchFormProps) {
  return <AlgoliaCategorySearchResults {...props} Prev={AlgoliaPageSearchResultsInterceptor} />
}
export const SearchForm = AlgoliaCategorySearchResultsInterceptor

/**
 * Interceptor for `<ProductListFiltersSearch/>` with these plugins:
 * 
 * - `@graphcommerce/algolia-search/plugins/AlgoliaFiltersPlugin`
 */
type ProductListFiltersSearchProps = ComponentProps<typeof ProductListFiltersSearchBase>

function AlgoliaFiltersPluginInterceptor(props: ProductListFiltersSearchProps) {
  return <AlgoliaFiltersPlugin {...props} Prev={ProductListFiltersSearchBase} />
}
export const ProductListFiltersSearch = AlgoliaFiltersPluginInterceptor

/**
 * Interceptor for `<ProductListPaginationSearch/>` with these plugins:
 * 
 * - `@graphcommerce/algolia-search/plugins/AlgoliaPaginationPlugin`
 */
type ProductListPaginationSearchProps = ComponentProps<typeof ProductListPaginationSearchBase>

function AlgoliaPaginationPluginInterceptor(props: ProductListPaginationSearchProps) {
  return <AlgoliaPaginationPlugin {...props} Prev={ProductListPaginationSearchBase} />
}
export const ProductListPaginationSearch = AlgoliaPaginationPluginInterceptor

/**
 * Interceptor for `<ProductListCountSearch/>` with these plugins:
 * 
 * - `@graphcommerce/algolia-search/plugins/AlgoliaProductListCountPlugin`
 */
type ProductListCountSearchProps = ComponentProps<typeof ProductListCountSearchBase>

function AlgoliaProductListCountPluginInterceptor(props: ProductListCountSearchProps) {
  return <AlgoliaProductListCountPlugin {...props} Prev={ProductListCountSearchBase} />
}
export const ProductListCountSearch = AlgoliaProductListCountPluginInterceptor

/**
 * Interceptor for `<ProductListItemsSearch/>` with these plugins:
 * 
 * - `@graphcommerce/algolia-search/plugins/AlgoliaProductSearchResultsPlugin`
 */
type ProductListItemsSearchProps = ComponentProps<typeof ProductListItemsSearchBase>

function AlgoliaProductSearchResultsPluginInterceptor(props: ProductListItemsSearchProps) {
  return <AlgoliaProductSearchResultsPlugin {...props} Prev={ProductListItemsSearchBase} />
}
export const ProductListItemsSearch = AlgoliaProductSearchResultsPluginInterceptor

/**
 * Interceptor for `<ProductListSortSearch/>` with these plugins:
 * 
 * - `@graphcommerce/algolia-search/plugins/AlgoliaProductSortPlugin`
 */
type ProductListSortSearchProps = ComponentProps<typeof ProductListSortSearchBase>

function AlgoliaProductSortPluginInterceptor(props: ProductListSortSearchProps) {
  return <AlgoliaProductSortPlugin {...props} Prev={ProductListSortSearchBase} />
}
export const ProductListSortSearch = AlgoliaProductSortPluginInterceptor

/**
 * Interceptor for `<SearchContext/>` with these plugins:
 * 
 * - `@graphcommerce/algolia-search/plugins/AlgoliaSearchContextPlugin`
 */
type SearchContextProps = ComponentProps<typeof SearchContextBase>

function AlgoliaSearchContextPluginInterceptor(props: SearchContextProps) {
  return <AlgoliaSearchContextPlugin {...props} Prev={SearchContextBase} />
}
export const SearchContext = AlgoliaSearchContextPluginInterceptor
